import { render, staticRenderFns } from "./AutoWorkbenchDialog.vue?vue&type=template&id=38c8187e&scoped=true"
import script from "./AutoWorkbenchDialog.vue?vue&type=script&lang=js"
export * from "./AutoWorkbenchDialog.vue?vue&type=script&lang=js"
import style0 from "./AutoWorkbenchDialog.vue?vue&type=style&index=0&id=38c8187e&prod&scoped=true&lang=css"
import style1 from "./AutoWorkbenchDialog.vue?vue&type=style&index=1&id=38c8187e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c8187e",
  null
  
)

export default component.exports